import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { css } from 'emotion'
import ReactGA from 'react-ga';

import Header from '../components/header'
import Footer from '../components/footer'

import '../styles/app.sass'
import LiveChat from '../utils/livechat'

const ContentClass = css`
  margin-top: 5.1rem;
`

ReactGA.initialize('UA-118290333-1');

const Layout = ({ children, data, ...props }) => {
  const hasFrame = props.location.search.indexOf('frame=true') > -1
  if (!hasFrame) {
    LiveChat(process.env)
  }
  return (
    <div className={`${hasFrame ? 'hasFrame' : ''}`}>
      <Helmet
        title={data.site.siteMetadata.title}
        meta={[
          { name: 'description', content: data.site.siteMetadata.description }
        ]}
      />
      <Header {...data.landing} />
      <div className={ContentClass}>
        {children()}
      </div>
      <Footer/>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title,
        description
      }
    }
    landing: allMarkdownRemark(
      filter: { frontmatter: { dropdown: { eq: true } }}
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            label
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js